import { createSlice } from "@reduxjs/toolkit";
import { addCatalog, deletedCatalog, getCatalogs, getDescendants, updateCatalog } from "./thunk";


export const initialState: any = {
  catalogList: [],
  descendants: {},
  error: {},
};

const formDataToJson = (formData: any) => {
  const jsonObject: any = {};
  formData.forEach((value: any, key: any) => {
    if (key === 'jsonData') {
      jsonObject[key] = JSON.parse(value);
      return
    }
    jsonObject[key] = value;
  });
  return jsonObject;
};

const CatalogSlice = createSlice({
  name: 'CatalogSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //Get DigitalSignature
    builder.addCase(getCatalogs.fulfilled, (state: any, action: any) => {
      state.catalogList = action.payload;
    });
    builder.addCase(getCatalogs.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    //
    //Get Descendants

    builder.addCase(getDescendants.fulfilled, (state: any, action: any) => {
      const catalogId = action.meta.arg;
      state.descendants[catalogId] = action.payload.children;
    });
    builder.addCase(getDescendants.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    //Add Catalog

    builder.addCase(addCatalog.fulfilled, (state: any, action: any) => {
      state.catalogList = [...state.catalogList, action.payload];
    });


    builder.addCase(addCatalog.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    // Update Catalog

    builder.addCase(updateCatalog.fulfilled, (state: any, action: any) => {

      state.catalogList = state.catalogList.map((catalog: any) => {
          return catalog.id === action.payload.id
            ? { ...catalog, ...formDataToJson(action.meta.arg.catalog) }
            : catalog
        }
      );
    });

    builder.addCase(updateCatalog.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    //Delete Catalog

    builder.addCase(deletedCatalog.fulfilled, (state: any, action: any) => {
      state.catalogList = (state.catalogList || []).filter((catalog: any) => catalog.id !== action.payload.id);
    })

    builder.addCase(deletedCatalog.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

  }
});

export default CatalogSlice.reducer;
